type Props = {
  size?: 'xs' | 'sm';
  className?: string;
};

export function PromoCodeOnlyBadge({ size = 'sm', className = '' }: Props) {
  const iconClass = size === 'xs' ? 'w-3 h-3' : 'w-4 h-4';
  const textClass = size === 'xs' ? 'text-xs' : 'text-sm';
  return (
    <div className={`flex items-center gap-1 text-blue-600 ${textClass} ${className}`}>
      <svg className={`${iconClass} flex-shrink-0`} fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden="true">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M7 7h.01M7 3h5c.512 0 1.024.195 1.414.586l7 7a2 2 0 010 2.828l-7 7a2 2 0 01-2.828 0l-7-7A2 2 0 013 12V7a4 4 0 014-4z" />
      </svg>
      <span>Promo code only</span>
    </div>
  );
}
